import breadcrumbComp from "../../../src/components/common/breadcrumb-comp.vue";
import ReadMore from "../../../src/components/common/read-more.vue";
import btoService from "./bto-service";
import EncryptUtility from "../../components/utility/js/encrypt-utility";
import Utility from "../../shared/utility";
import AddFavourite from "../../components/utility/js/addFav";
import PrinterDetails from "../../components/common/printer-details.vue";
export default {
  data() {
    return {
      mainPage: "",
      actionList: "",
      favouriteList: "",
      pageUrl: "",
      subPage: "",
      showAdd: "",
      backSlash: true,
      refresh: true,
      btoSearch: "",
      btoSearchFormValid: false,
      totalRecords: 0,
      expanded: [],
      showFilter: false,
      disableBusiness: false,
      disableWarehouse: false,
      disableStatus: false,
      selectedProject: [],
      selectedBusiness: [],
      selectedWarehouse: [],
      selectedStatus: [],
      selectedFilterName: "",
      disableRun: true,
      hasPendingBtoFilterChanges: false,
      userId: EncryptUtility.localStorageDecrypt("userID"),
      projectList: [],
      searchFilter: "",
      btoListData: [],
      activeDashboardFilter: "",
      arrayData: [],
      showPrimary: true,
      printerConfigured: false,
      uniqueStatus: [],
      labelValue: false,
      json_fields:{
        Project: "project",
        Business: "business",
        "Warehouse": "ware",
        "BTO/KIT #":"bono",
        "RLP Order": "sono",
        "RMA": "rma",
        "Request Number": "request_number",
        "Customer Id": "cust_num",
        "Part Number": "part_num",
        "SCTASK": "reasn_code",
        "Unit ID": "unit_id",
        "RITM": "ritm",
        "Status": "status",
        "SLA": "SLA",
        "LPN": "lpn",
        "Bin": "bin",
        "Source Date": "assign_date",
      },
      excelName :
        'BTO_List_' +
        new Date()
          .toISOString()
          .replace('T', '_')
          .replace('Z', '')
          .replace('.', '')
          .replaceAll('-', '_') +
        '.xls',
      max3Rule: [
        (v) => (v || "").length >= 3 || "Min Length of 3 character",
        (v) => (v || "").length > 0 || "Min Length of 3 character",
      ],
      businessList: [],
      warehouseList: [],
      statusList: [],
      btoListTemp: [],
      btoFilterLoadRequestId: 0,
      btoDropdownCache: {},
      suppressNextBtoFilterChange: false,
      isApplyingBtoFilters: false,
      btoPendingApplyTimer: null,
      btoDashboardSummary: {
        total: 0,
        hold: 0,
        slaCounts: {},
        statusBreakdown: [],
      },
      btoListHeader: [
        { text: "SLA", value: "SLA", align: "center", class: "primary customwhite--text" },
        {
          text: "",
          value: "data-table-expand",
          class: "primary customwhite--text",
        },
        { text: "", value: "type_icon", class: "primary customwhite--text" },
        {
          text: "Project/Business",
          value: "project",
          class: "primary customwhite--text",
        },
        {
          text: "Warehouse",
          value: "ware",
          class: "primary customwhite--text",
        },
        {
          text: "BTO/KIT #",
          value: "bono",
          class: "primary customwhite--text",
        },
        {
          text: "RLP Order",
          value: "sono",
          class: "primary customwhite--text",
        },
        {
          text: "Customer ID",
          value: "cust_num",
          class: "primary customwhite--text",
        },
        {
          text: "Part Number",
          value: "part_num",
          class: "primary customwhite--text",
        },
        {
          text: "Unit ID",
          value: "unit_id",
          class: "primary customwhite--text",
        },
        { text: "Status", value: "status", class: "primary customwhite--text" },
        { text: "Bin/LPN", value: "bin", class: "primary customwhite--text" },
        {
          text: "Source Date",
          value: "assign_date",
          class: "primary customwhite--text",
        },
        {
          text: "Action",
          value: "actions",
          class: "primary customwhite--text",
        },
      ],
      filterObj: {
        UserID: EncryptUtility.localStorageDecrypt("userID"),
        ddl_pass: 0,
        projkey_list: "[]",
        bukey_list: "[]",
        whkey_list: "[]",
      },
    };
  },
  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList = data.actionList;
    this.mainPage = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl = data.pageUrl;
    this.subPage = data.subPage;
    this.showAdd = data.showAdd;
    if (EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== null && EncryptUtility.localStorageDecrypt("LabelSwitchValue") !== undefined) {
      this.labelValue = JSON.parse(EncryptUtility.localStorageDecrypt("LabelSwitchValue"));
    }    
    this.onChangeLabelFunction(this.labelValue);
  },
  computed: {
    hasSelectedBtoFilters() {
      return Boolean(
        this.selectedProject?.length ||
        this.selectedBusiness?.length ||
        this.selectedWarehouse?.length ||
        this.selectedStatus?.length
      );
    },
    showBtoDashboard() {
      return this.hasSelectedBtoFilters && Boolean(this.btoListTemp?.length);
    },
    btoDashboardCards() {
      return [
        {
          label: "Total BTO/KITs",
          value: this.btoDashboardSummary.total,
          icon: "mdi-view-dashboard-outline",
          color: "#2563eb",
          filterType: "all",
        },
        {
          label: "Shipping Hold",
          value: this.btoDashboardSummary.hold,
          icon: "mdi-truck-alert-outline",
          color: "#dc2626",
          filterType: "hold",
        },
        {
          label: "On-Time",
          value: this.btoDashboardSummary.slaCounts["ON-TIME"] || 0,
          icon: "mdi-clock-check-outline",
          color: "#16a34a",
          filterType: "sla:ON-TIME",
        },
        {
          label: "Must Ship",
          value: this.btoDashboardSummary.slaCounts["MUST SHIP"] || 0,
          icon: "mdi-alert-circle-outline",
          color: "#f59e0b",
          filterType: "sla:Must Ship",
        },
        {
          label: "Past Due",
          value: this.btoDashboardSummary.slaCounts["PAST DUE"] || 0,
          icon: "mdi-clock-alert-outline",
          color: "#dc2626",
          filterType: "sla:Past Due",
        },
      ];
    },
    btoStatusBreakdown() {
      return this.btoDashboardSummary.statusBreakdown;
    },
  },
  async mounted() {
    if (EncryptUtility.localStorageDecrypt("btoSearch")) {
      let jsonData = JSON.parse(
        EncryptUtility.localStorageDecrypt("btoSearch")
      );
      const filterData = JSON.parse(jsonData.json);
      this.selectedProject = filterData.projkey_list || [];
      this.selectedBusiness = filterData.bukey_list || [];
      this.selectedWarehouse = filterData.whkey_list || [];
      this.selectedStatus = filterData.status_list || [];
      this.disableRun = !this.hasSelectedBtoFilters;
      await this.refreshBtoFilterDropdowns();
      await this.loadBtoFilterSearch();
    } else {
      await this.refreshBtoFilterDropdowns();
    }
    // if(EncryptUtility.localStorageDecrypt("quickSearch")){
    //   this.btoSearch = EncryptUtility.localStorageDecrypt("quickSearch");
    //   this.onClickSearch();
    // }
  },
  methods: {
    hasHoldPrefix(orderNo) {
      return String(orderNo || "")
        .replace(/<[^>]*>/g, "")
        .toUpperCase()
        .includes("[HOLD]-");
    },
    actionSetter(permission) {
      return Utility.actionSetter(this.actionList, permission);
    },
    async onClickSearch() {
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.selectedWarehouse = [];
      this.selectedStatus = []; 
      // const validation=EncryptUtility.localStorageDecrypt("quickSearch")?true:this.$refs.btoSearchForm?.validate();
      if (this.$refs.btoSearchForm?.validate()) {
        EncryptUtility.localStorageEncrypt("btoSearch", "");
        let resp = await btoService.getBtoListQuickSearch(
          "get",
          this.userId,
          this.btoSearch
        );
        // EncryptUtility.localStorageEncrypt("quickSearch", this.btoSearch);
        this.tableData(resp);
      }
    },
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },
    onClickExport() {
      this.btoListData?.forEach((element) => {
          element.assign_date = Utility.displayDateFormat(element.assign_date);
        });
    },
    clearTable() {
      this.btoFilterLoadRequestId += 1;
      this.totalRecords = 0;
      this.btoListData = [];
      this.btoListTemp = [];
      this.activeDashboardFilter = "";
      this.btoDashboardSummary = this.buildBtoDashboardSummary([]);
      this.showFilter = false;
    },
    async onFilterSelectionChange(filterRef = "") {
      if (this.suppressNextBtoFilterChange) {
        return;
      }
      this.$refs.btoSearchForm.resetValidation();
      this.filterObj.projkey_list = JSON.stringify(this.selectedProject);
      this.disableRun = !this.hasSelectedBtoFilters;
      this.hasPendingBtoFilterChanges = true;
      await this.$nextTick();
      if (!this.isBtoFilterDropdownOpen(filterRef)) {
        await this.applyBtoFilters(filterRef);
      }
    },
    applyPendingBtoFilters(filterRef = "") {
      if (!this.hasPendingBtoFilterChanges || this.isApplyingBtoFilters) return;
      if (this.btoPendingApplyTimer) {
        clearTimeout(this.btoPendingApplyTimer);
      }
      this.btoPendingApplyTimer = setTimeout(async () => {
        this.btoPendingApplyTimer = null;
        if (this.hasPendingBtoFilterChanges && !this.isApplyingBtoFilters) {
          await this.applyBtoFilters(filterRef);
        }
      }, 150);
    },
    getBtoFilterConfig(filterName) {
      const filterConfig = {
        project: { selectedKey: "selectedProject", itemKey: "proj_key", textKey: "project" },
        business: { selectedKey: "selectedBusiness", itemKey: "bu_key", textKey: "business" },
        warehouse: { selectedKey: "selectedWarehouse", itemKey: "ware_key", textKey: "ware" },
        status: { selectedKey: "selectedStatus" },
      }[filterName];
      return filterConfig;
    },
    getBtoFilterSelectionValue(filterName, item) {
      const filterConfig = this.getBtoFilterConfig(filterName);
      if (!filterConfig) return item;
      return filterConfig.itemKey ? item?.[filterConfig.itemKey] ?? item : item;
    },
    getBtoFilterSelectionText(filterName, item) {
      const filterConfig = this.getBtoFilterConfig(filterName);
      if (!filterConfig) return item;
      return filterConfig.textKey ? item?.[filterConfig.textKey] ?? item : item;
    },
    async removeBtoFilterSelection(filterName, item, filterRef = "") {
      const filterConfig = this.getBtoFilterConfig(filterName);
      if (!filterConfig) return;
      const removedValue = this.getBtoFilterSelectionValue(filterName, item);
      this[filterConfig.selectedKey] = (this[filterConfig.selectedKey] || []).filter(
        (value) => String(value) !== String(removedValue)
      );
      this.hasPendingBtoFilterChanges = true;
      await this.applyBtoFilters(filterRef);
    },
    async clearBtoFilterSelection(filterName, filterRef = "") {
      const filterConfig = this.getBtoFilterConfig(filterName);
      if (!filterConfig) return;
      this.suppressNextBtoFilterChange = true;
      this[filterConfig.selectedKey] = [];
      this.hasPendingBtoFilterChanges = true;
      try {
        await this.$nextTick();
        await this.applyBtoFilters(filterRef);
        await this.$nextTick();
      } finally {
        this.suppressNextBtoFilterChange = false;
      }
    },
    async getCachedBtoDropdown(type, call, obj, showMessage) {
      const cacheKey = `${type}:${JSON.stringify(obj)}`;
      if (this.btoDropdownCache[cacheKey]) {
        return this.btoDropdownCache[cacheKey];
      }
      const data = await btoService.getBtoListDropDown(call, obj, showMessage);
      this.btoDropdownCache[cacheKey] = data;
      return data;
    },
    buildBtoDropdownPayload() {
      return {
        ...this.filterObj,
        ddl_pass: 0,
        projkey_list: JSON.stringify(this.selectedProject),
        bukey_list: JSON.stringify(this.selectedBusiness),
        whkey_list: JSON.stringify(this.selectedWarehouse),
      };
    },
    async refreshBtoFilterDropdowns(forceRefresh = false) {
      const dropdownPayload = this.buildBtoDropdownPayload();
      const dropdownData = forceRefresh
        ? await btoService.getBtoListDropDown("post", dropdownPayload, false)
        : await this.getCachedBtoDropdown("all", "post", dropdownPayload, false);
      this.applyBtoDropdownData(dropdownData);
      this.selectedProject = this.pruneUnavailableSelections(this.selectedProject, this.projectList, "proj_key");
      this.selectedBusiness = this.pruneUnavailableSelections(this.selectedBusiness, this.businessList, "bu_key");
      this.selectedWarehouse = this.pruneUnavailableSelections(this.selectedWarehouse, this.warehouseList, "ware_key");
      this.selectedStatus = this.pruneUnavailableSelections(this.selectedStatus, this.statusList);
      this.disableRun = !this.hasSelectedBtoFilters;
    },
    applyBtoDropdownData(dropdownData) {
      const normalizedData = this.normalizeBtoDropdownResponse(dropdownData);
      const projects = this.extractDropdownList(normalizedData, ["projectList", "projects", "project"]);
      const businesses = this.extractDropdownList(normalizedData, ["businessList", "businesses", "business"]);
      const warehouses = this.extractDropdownList(normalizedData, ["warehouseList", "warehouses", "warehouse"]);
      const statuses = this.extractDropdownList(normalizedData, ["statusList", "statuses", "status"]);
      if (projects.length) this.projectList = this.uniqueDropdownItems(projects, "proj_key");
      if (businesses.length) this.businessList = this.uniqueDropdownItems(businesses, "bu_key");
      if (warehouses.length) this.warehouseList = this.uniqueDropdownItems(warehouses, "ware_key");
      if (statuses.length) this.statusList = this.uniqueDropdownItems(
        statuses.map((item) => item?.PStatus || item?.status || item).filter(Boolean)
      );
    },
    normalizeBtoDropdownResponse(dropdownData) {
      if (!Array.isArray(dropdownData) || dropdownData.length !== 1 || typeof dropdownData[0] !== "object") {
        return dropdownData;
      }
      return Object.values(dropdownData[0]).some((value) => Array.isArray(value)) ? dropdownData[0] : dropdownData;
    },
    extractDropdownList(dropdownData, keys) {
      if (Array.isArray(dropdownData)) {
        const keyMatch = {
          project: (item) => item?.proj_key !== undefined || item?.project !== undefined,
          business: (item) => item?.bu_key !== undefined || item?.business !== undefined,
          warehouse: (item) => item?.ware_key !== undefined || item?.ware !== undefined,
          status: (item) => item?.PStatus !== undefined || item?.status !== undefined,
        };
        const inferredKey = Object.keys(keyMatch).find((key) => keys.includes(key) && dropdownData.some(keyMatch[key]));
        return inferredKey ? dropdownData.filter(keyMatch[inferredKey]) : [];
      }
      if (!dropdownData || typeof dropdownData !== "object") return [];
      for (const key of keys) {
        if (Array.isArray(dropdownData[key])) return dropdownData[key];
        const caseInsensitiveKey = Object.keys(dropdownData).find((itemKey) => itemKey.toLowerCase() === key.toLowerCase());
        if (caseInsensitiveKey && Array.isArray(dropdownData[caseInsensitiveKey])) return dropdownData[caseInsensitiveKey];
      }
      return [];
    },
    uniqueDropdownItems(items, itemValueKey) {
      const seen = new Set();
      return (items || []).filter((item) => {
        const value = String(itemValueKey ? item?.[itemValueKey] : item);
        if (!value || seen.has(value)) return false;
        seen.add(value);
        return true;
      });
    },
    pruneUnavailableSelections(selectedValues, availableItems, itemValueKey) {
      if (!selectedValues?.length || !availableItems?.length) return [];
      const availableValues = new Set(
        availableItems.map((item) => String(itemValueKey ? item?.[itemValueKey] : item))
      );
      return selectedValues.filter((value) => availableValues.has(String(value)));
    },
    tableData(resp) {
      this.btoListData = resp;
      if (resp) {
        this.showFilter = true;
        this.totalRecords = resp.length;
        this.expanded = this.btoListData
          .filter((item) => item.config_notes)
          .map((item) => item.line_id);
        this.btoListData?.forEach((element) => {
          element.assign_date = Utility.displayDateFormat(element.assign_date);
        });
        this.btoListTemp = this.btoListData;
        this.updateBtoListDerivedData(this.btoListTemp);
        this.activeDashboardFilter = "";
      } else {
        this.clearTable();
      }
    },
    updateBtoListDerivedData(sourceData) {
      const statusMap = {};
      sourceData.forEach((item) => {
        const status = item?.status || "Unassigned";
        statusMap[status] = (statusMap[status] || 0) + 1;
      });
      this.uniqueStatus = Object.keys(statusMap);
      this.arrayData = [{ id: 1, label: "Status", array: this.uniqueStatus }];
      this.btoDashboardSummary = this.buildBtoDashboardSummary(sourceData, statusMap);
    },
    buildBtoDashboardSummary(sourceData, statusMap = null) {
      const data = sourceData || [];
      const total = data.length;
      let hold = 0;
      const slaCounts = {};
      const resolvedStatusMap = statusMap || {};
      data.forEach((item) => {
        const sla = this.normalizeSla(item);
        if (sla) slaCounts[sla] = (slaCounts[sla] || 0) + 1;
        if (this.hasHoldPrefix(item?.sono)) hold += 1;
        if (!statusMap) {
          const status = item?.status || "Unassigned";
          resolvedStatusMap[status] = (resolvedStatusMap[status] || 0) + 1;
        }
      });
      const statusBreakdown = Object.keys(resolvedStatusMap)
        .map((status, index) => ({
          status,
          total: resolvedStatusMap[status],
          percent: total ? (resolvedStatusMap[status] / total) * 100 : 0,
          color: this.statusBarColor(index),
        }))
        .sort((a, b) => b.total - a.total);
      return { total, hold, slaCounts, statusBreakdown };
    },
    async applyBtoFilters(filterRef = "") {
      if (this.isApplyingBtoFilters) return;
      if (this.btoPendingApplyTimer) {
        clearTimeout(this.btoPendingApplyTimer);
        this.btoPendingApplyTimer = null;
      }
      this.isApplyingBtoFilters = true;
      this.activeDashboardFilter = "";
      try {
        if (!this.hasSelectedBtoFilters) {
          await this.refreshBtoFilterDropdowns(true);
          this.clearTable();
          EncryptUtility.localStorageEncrypt("btoSearch", "");
          this.hasPendingBtoFilterChanges = false;
          this.closeBtoFilterDropdown(filterRef);
          return;
        }
        await this.refreshBtoFilterDropdowns(true);
        await this.loadBtoFilterSearch();
        this.hasPendingBtoFilterChanges = false;
        this.closeBtoFilterDropdown(filterRef);
      } finally {
        this.isApplyingBtoFilters = false;
      }
    },
    closeBtoFilterDropdown(filterRef) {
      if (!filterRef || !this.$refs?.[filterRef]) return;
      this.$nextTick(() => {
        const filter = this.$refs[filterRef];
        if (filter?.blur) filter.blur();
        if (filter?.isMenuActive !== undefined) filter.isMenuActive = false;
      });
    },
    isBtoFilterDropdownOpen(filterRef) {
      if (!filterRef || !this.$refs?.[filterRef]) return false;
      return Boolean(this.$refs[filterRef]?.isMenuActive);
    },
    buildBtoFilterSearchPayload() {
      let jsonObj = {
        projkey_list: this.selectedProject,
        bukey_list: this.selectedBusiness,
        whkey_list: this.selectedWarehouse,
        status_list: this.selectedStatus,
      };
      return {
        user_id: this.userId,
        json: JSON.stringify(jsonObj),
      };
    },
    async loadBtoFilterSearch() {
      this.disableRun = !this.hasSelectedBtoFilters;
      if (!this.hasSelectedBtoFilters) {
        this.clearTable();
        EncryptUtility.localStorageEncrypt("btoSearch", "");
        return;
      }
      // EncryptUtility.localStorageEncrypt("quickSearch", "");  
      this.btoSearch = "";
      const requestId = ++this.btoFilterLoadRequestId;
      const obj = this.buildBtoFilterSearchPayload();
      EncryptUtility.localStorageEncrypt("btoSearch", JSON.stringify(obj));
      let resp = await btoService.getBtoFilterSearch("post", obj, false);
      if (requestId !== this.btoFilterLoadRequestId) return;
      this.tableData(resp);
    },
    clearObject() {
      this.filterObj = {
        UserID: EncryptUtility.localStorageDecrypt("userID"),
        ddl_pass: 0,
        projkey_list: "[]",
        bukey_list: "[]",
        whkey_list: "[]",
        // status_list: "[]",
      };
      this.selectedProject = [];
      this.selectedBusiness = [];
      this.selectedWarehouse = [];
      this.selectedStatus = [];
      this.showFilter = false;
      this.disableRun = true;
      this.hasPendingBtoFilterChanges = false;
      this.disableStatus = false;
      this.disableWarehouse = false;
      this.disableBusiness = false;
      EncryptUtility.localStorageEncrypt("btoSearch", "");
      // EncryptUtility.localStorageEncrypt("quickSearch", "");

    },
    async clearFilter() {
      this.$refs.btoSearchForm.resetValidation(); 
      this.clearObject();
      this.clearTable();
      if (!this.hasSelectedBtoFilters) {
        await this.refreshBtoFilterDropdowns(true);
      }
    },
    async resetPage() {
      this.btoSearch = "";
      if (this.hasSelectedBtoFilters) {
        this.activeDashboardFilter = "";
        await this.refreshBtoFilterDropdowns(true);
        await this.loadBtoFilterSearch();
        return;
      }
      await this.clearFilter();
      EncryptUtility.localStorageEncrypt("btoSearch", "");
      this.disableRun = true;
    },
    onClickDetails(item) {
      let bto_id = item.bono;
      this.$router.push(`/bto-details/${btoa(bto_id.toString())}`);
    },
    filterArrayData() {
      this.uniqueStatus = [
        ...new Map(
          this.btoListData.map((item) => [item["status"], item.status])
        ).values(),
      ];

      this.arrayData = [{ id: 1, label: "Status", array: this.uniqueStatus }];
    },
    async filteredValues(value, type) {
      const filters = {
        0: () => this.btoListTemp,
        1: (value) =>
          this.btoListTemp.filter((element) => element.status == value),
      };
      this.activeDashboardFilter = type === 1 ? `status:${value}` : "all";
      this.filterValueUpdate(filters[type](value));
    },
    filterValueUpdate(data) {
      this.totalRecords = data.length;
      this.btoListData = data;
    },
    filterDashboardQueue(type, value = "") {
      let normalizedType = type;
      let normalizedValue = value;
      if (type?.includes(":")) {
        const filterParts = type.split(":");
        normalizedType = filterParts[0];
        normalizedValue = filterParts.slice(1).join(":");
      }
      const sourceData = this.btoListTemp?.length ? this.btoListTemp : this.btoListData;
      const filters = {
        all: () => sourceData,
        hold: () => sourceData.filter((item) => this.hasHoldPrefix(item?.sono)),
        sla: () => sourceData.filter((item) => this.normalizeSla(item) === normalizedValue.toUpperCase()),
        status: () => sourceData.filter((item) => (item?.status || "Unassigned") === normalizedValue),
      };
      const filterKey = normalizedType === "status" || normalizedType === "sla" ? `${normalizedType}:${normalizedValue}` : normalizedType;
      this.activeDashboardFilter = filterKey;
      this.searchFilter = "";
      this.filterValueUpdate((filters[normalizedType] || filters.all)());
    },
    uniqueCount(items, key) {
      return new Set((items || []).map((item) => item?.[key]).filter(Boolean)).size;
    },
    formatDashboardNumber(value) {
      const numberValue = Number(value);
      return Number.isFinite(numberValue) ? numberValue.toLocaleString() : "0";
    },
    rawSlaValue(item) {
      return String(item?.SLA || item?.sla || "")
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/gi, " ")
        .trim();
    },
    normalizeSla(item) {
      const sla = this.rawSlaValue(item).toUpperCase();
      const compactSla = sla.replace(/[\s-_]/g, "");
      if (compactSla.includes("ONTIME")) return "ON-TIME";
      if (compactSla.includes("MUSTSHIP")) return "MUST SHIP";
      if (compactSla.includes("PASTDUE")) return "PAST DUE";
      return sla;
    },
    slaDisplay(item) {
      return this.normalizeSla(item) || "-";
    },
    slaDotColor(item) {
      const sla = this.normalizeSla(item);
      if (sla === "ON-TIME") return "#16a34a";
      if (sla === "MUST SHIP") return "#f59e0b";
      if (sla === "PAST DUE") return "#dc2626";
      return "#64748b";
    },
    statusBarColor(index) {
      const colors = ["#2563eb", "#16a34a", "#f59e0b", "#dc2626", "#0f766e", "#7c3aed", "#64748b"];
      return colors[index % colors.length];
    },

    printerDetails(labelPrinter) {
      if (!labelPrinter) {
        this.printDisable = false;
        this.printerConfigured = false;
      } else {
        this.printDisable = true;
        this.printerConfigured = true;
      }
    },
    //Label change function
    onChangeLabelFunction(val) {
      this.labelValue = val;
      EncryptUtility.localStorageEncrypt("LabelSwitchValue", JSON.stringify(this.labelValue));
    },
    getSourceConfigBTOPrint(item) {
      let LoaderDialog = {
        visible: true,
        title: "Please Wait...",
      };
      this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
      this.axios
        .get(
          "usb/sourcing_configuration_kits_bto_print_html?user_id=" +
            this.userId +
            "&line_id=" +
            item.line_id
        )
        .then((response) => {
          if (response.status == 200) {
            Utility.printZPLPDF(
              response.data.body.message,
              EncryptUtility.localStorageDecrypt("defaultName")
            );
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          } else {
            LoaderDialog.visible = false;
            this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
            var Alert = {
              type: "error",
              isShow: true,
              message: response.data.message,
            };
            this.$store.commit("ConfigModule/Alert", Alert);
          }
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
        })
        .catch((error) => {
          LoaderDialog.visible = false;
          this.$store.commit("ConfigModule/LoaderDialog", LoaderDialog);
          var Alert = {
            type: "error",
            isShow: true,
            message: Utility.apiError(error),
          };
          this.$store.commit("ConfigModule/Alert", Alert);
          this.errorMessage = error.message;
        });
    },
  },
  components: {
    breadcrumbComp,
    ReadMore,
    PrinterDetails,
  },
};
